import {
  black2,
  black3,
  bold,
  evisortBlue,
  evisortRed,
} from '~/assets/shared-styles/general';

const stylesFactory = (hasError) => ({
  container: (styles, state) => {
    return {
      ...styles,
      width: state.selectProps.width || '240px',
    };
  },
  clearIndicator: (styles) => {
    return {
      ...styles,
      color: black3,
      cursor: 'pointer',
      '&:hover': { color: black2 },
    };
  },
  control: (styles, state) => {
    return {
      ...styles,
      height: '44px',
      borderColor: state.isFocused
        ? evisortBlue
        : hasError
          ? evisortRed
          : 'rgba(0, 0, 0, 0.2)',
      borderWidth: state.isFocused ? 2 : 1,
      color: black2,
      fontSize: '15px',
      boxShadow: 'none',
      cursor: 'pointer',
      caretColor: evisortBlue,

      '&:hover': {
        borderColor: evisortBlue,
      },
      '@media (prefers-contrast: more)': {
        outline: state.isFocused ? 'auto' : null,
      },
    };
  },
  loadingIndicator: (styles) => {
    return {
      ...styles,
      '& span': {
        backgroundColor: evisortBlue,
      },
    };
  },
  menuList: (styles) => {
    return {
      ...styles,
      borderRadius: '4px',
    };
  },
  multiValue: (styles) => {
    return {
      ...styles,
      display: 'none',
    };
  },
  option: (styles, state) => {
    const { isFocused, isSelected } = state;

    return {
      ...styles,
      backgroundColor: isSelected || isFocused ? evisortBlue : '#fff',
      color: isSelected || isFocused ? '#fff' : black2,
      fontSize: '15px',
      fontWeight: state.data.bold ? bold : null,
      cursor: 'pointer',
      // react-select has no focus-visible, and isFocused has effect in light mode.
      // Therefore, to provide an outline for dark mode, theme detection is the best option for now
      '@media (prefers-contrast: more)': {
        outline: isFocused ? 'auto' : null,
      },
    };
  },
  placeholder: (styles) => {
    return {
      ...styles,
      color: hasError ? evisortRed : black3,
    };
  },
});

export default stylesFactory;
